# GraphQL fragment to get basic info about a step template
# within the sales automation environment.

#import "../fragments/sales-automation-step-template.graphql"

mutation CreateStepTemplate($stepTemplate: CreateStepTemplateInputFieldInput!) {
    createStepTemplate(input: {stepTemplate: $stepTemplate}) {
        stepTemplate {
            ...SalesAutomationStepTemplate
        }
    }
}
